<template>
  <div>
    <div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div class="sm:mx-auto sm:w-full sm:max-w-full">
        <div class="py-8 px-4 sm:px-10">
          <ApplyReferralNew :record="contact" :team="team" />
        </div>
      </div>
    </div>
    <Alert ref="alert" />
  </div>
</template>

<script>
import Alert from '../shared/Alert.vue';
import ApplyReferralNew from './ApplyReferralNew.vue';

export default {
  components: {
    Alert,
    ApplyReferralNew,
  },
  data() {
    return {
      selectedTab: 'Apply',
      team: {
        companyLogo: '',
        company: '',
      },
      contact: {
        name: '',
      },
      noJobFound: false,
    };
  },
  mounted() {
    this.getReferralDetails();
  },
  methods: {
    getReferralDetails() {
      const self = this;
      self.$store.commit('general/showLoadingSpinner');
      fetch(`/public/apply_referral/${self.$route.params.id}`)
        .then(response => {
          self.$store.commit('general/hideLoadingSpinner');
          return response.json();
        })
        .then(data => {
          self.contact.name = data.record.name;
          self.team.companyLogo = data.team.company_logo;
          self.team.company = data.team.company;
        });
    },
  },
};
</script>
